/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Popup } from 'vant';
import { Component, Vue, Watch } from 'vue-property-decorator';
import router from '@/router';
import { popPageManager } from '@/shared/tools/popPageManager';
import { sleep } from '@/shared/utils/sleep';
import store from '@/store';

import { nativeLocalRemoveData, setPageTitle } from '@/api/native/utils';
import platform from '@/shared/utils/platform';
import { local } from '@/shared/utils/storage';
import TradeKeyComponent from '../trade-key-component';

@Component({ name: 'TradeKeyPop' })
class TradeKeyPop extends Vue {
  $refs!: {
    TradeKeyComponent: TradeKeyComponent;
  };

  private show = false;

  private resolve!: PromiseResolve<string>;

  private reject!: PromiseReject;

  @Watch('show')
  private onchange(val: boolean) {
    if (!val) {
      this.removeData();
    }
  }

  private async removeData() {
    if (platform.isHelloIosApp) {
      await nativeLocalRemoveData({ key: 'finance_applyProductLocal' });
    } else {
      local.remove('relationNo');
    }
  }

  public async open(commodityId: string): Promise<string> {
    this.show = true;
    await sleep();

    try {
      await this.$refs.TradeKeyComponent.init(commodityId);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    } catch (e) {
      this.show = false;
      setPageTitle(this.pageTitle);

      return Promise.reject(e);
    }
  }

  private get pageTitle(): string {
    return String(
      this.$route && this.$route.meta && this.$route.meta.title
        ? this.$route.meta.title
        : '',
    );
  }

  public close() {
    this.show = false;

    if (this.reject) {
      this.reject();
    }
    setPageTitle(this.pageTitle);
  }

  public get isOpen() {
    return this.show;
  }

  private onResolve(token: string) {
    this.resolve(token);
    this.close();
  }

  private render() {
    return (
      <Popup
        style={{ width: '100%', height: '100%' }}
        v-model={this.show}
        position="right"
      >
        <TradeKeyComponent
          ref="TradeKeyComponent"
          onResolve={(token: string) => this.onResolve(token)}
        />
      </Popup>
    );
  }
}

let instance: TradeKeyPop;

const TradeKey = {
  getToken({ commodityId }: { commodityId: string }): Promise<string> {
    if (!instance) {
      instance = new TradeKeyPop({ router, store }).$mount();
      document.body.appendChild(instance.$el);
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    popPageManager.addShowedPop(instance);

    return instance.open(commodityId);
  },

  /** 关闭交易密码弹窗 */
  close(): void {
    if (instance) {
      instance.close();
    }
  },

  /** 判断交易密码弹窗是否打开 */
  isOpen(): boolean {
    return instance ? instance.isOpen : false;
  },
};

export default TradeKey;
